module.exports = __webpack_public_path__ + "img/days_left_panel.04ab391f.png";